exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/brogliacci/brogliaccio-detail.component.css
// module id = ../../../../../src/app/components/brogliacci/brogliaccio-detail.component.css
// module chunks = main